import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/App.vue';
import { router } from '@/router';
import { useAuthStore } from '@/stores/auth';
import '@/styles/main.css';

async function bootstrap() {
  const app = createApp(App);
  const pinia = createPinia();
  app.use(pinia);

  // Proactively refresh on boot if the cached access token is expired but the
  // refresh token is still valid. Otherwise multiple components mount in
  // parallel, each fires a 401, and any transient backend hiccup during that
  // window would previously have wiped the session.
  const auth = useAuthStore();
  try {
    await auth.ensureFreshAccessToken();
  } catch {
    /* swallow — interceptor will retry reactively */
  }

  app.use(router);
  app.mount('#app');
}

bootstrap();
